export default {
  tenantContextDocuments: [],
  tenantContextDocumentsPagination: {
    page: 1,
    limit: 5,
    totalRows: 0,
    totalPages: 1,
  },
}
